
































import Vue from 'vue';
import Component from 'vue-class-component';

// @ is an alias to /src
import HelloWorld from '@/components/demo/hello-world.vue';
import MarkdownReader from '@/components/markdown-editor/MarkdownReader.vue';
import MarkdownEditor from '@/components/markdown-editor/MarkdownEditor.vue';
// mock
import { markdownReaderContent } from '../mock/markdown-reader';

@Component({
    components: { HelloWorld, MarkdownReader, MarkdownEditor },
})
export default class Demo extends Vue {
  private content = '';
  private contentData = markdownReaderContent;
    created() {
        window.addEventListener(
            'message',
            function(event) {
                if (event.origin !== 'http://dlab-local.datafountain.cn:8090') return;
                debugger;
                console.log('message received:  ' + event.data);
            },
            false
        );
    }

  private async doget() {
    const data = await this.$axios('demoUser', { id: 1 });
    console.log(data);
    debugger;
  }

  private async doPost() {
    const data = await this.$axios('demoAdd', { description: '测试demo' });
    console.log(data);
    debugger;
  }

  private async doPut() {
    const data = await this.$axios('demoPut', { xx: '123', yy: 456 });
    console.log(data);
    debugger;
  }

  private async doDelete() {
    const data = await this.$axios('demoDelete', { xx: '123', yy: 456 });
    console.log(data);
    debugger;
  }

  private async doTestError() {
    try {
      await this.$axios('demoTestError');
    } catch (e) {
      console.log(e);
    }
  }

  private async doTestLogin() {
    const data = await this.$axios('demoTestLogin');
    console.log(data);
    debugger;
  }
}
